module.exports = __webpack_public_path__ + "img/empty-team.0a5a87a.svg";